{
    "account.email_notifications": "E-mailmeldingen",
    "account.warnings_and_blocks": "Waarschuwingen en blokkeringen",
    "account_delete.confirm_description": "Het verwijderen van je profiel kan niet ongedaan worden gemaakt. Het kan tot 72 uur duren voordat alle gegevens en activiteit die aan dit profiel gekoppeld zijn, zijn verwijderd.",
    "account_delete.confirm_heading": "Weet je zeker dat je jouw profielgegevens wilt verwijderen?",
    "account_delete.heading": "Verwijder mijn gegevens",
    "account_request_data.heading": "Vraag mijn gegevens op",
    "action.cancel": "Annuleren",
    "action.create_new_voting": "Maak een nieuwe peiling",
    "action.delete": "Verwijderen",
    "action.edit": "Bewerk",
    "action.pinned": "Vastgemaakt",
    "action.post": "Plaatsen",
    "action.report": "Rapporteren",
    "action.save": "Opslaan",
    "admin.window_title": "Beheerder-dashboard",
    "admin_mod_link.admin_users_description": "Rechten van beheeraccounts aanpassen.",
    "admin_mod_link.developer_tools_label": "Ontwikkelaars-tools",
    "admin_mod_link.editorial_dashboard_description": "Beheer ruimtes en meer.",
    "admin_mod_link.editorial_dashboard_label": "Redactiedashboard",
    "admin_mod_link.moderation_dashboard_label": "Moderatie dashboard",
    "admin_mod_link.settings_description": "Beheer organisatiebrede sjablonen en functies.",
    "admin_mod_link.settings_label": "Instellingen",
    "admin_mod_link.storybook_description": "Bekijk PSI-componenten in Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Beheerders toevoegen",
    "admin_users.add_new_admins_label": "Nieuwe beheerders toevoegen",
    "admin_users.adding_admins_message": "Beheerders toevoegen...",
    "admin_users.emails_placeholder": "Mailadressen van toe te voegen gebruikers",
    "admin_users.heading": "Beheeraccounts",
    "admin_users.loading_message": "Beheerders laden...",
    "admin_users.updating_roles_message": "Rollen bijwerken...",
    "agree": "Eens",
    "aitag.ai_moderated": "AI-moderatie",
    "article.login_button": "Inloggen",
    "audience_input.community_guidelines_title": "Communityregels",
    "audience_input.composer_placeholder": "Deel je gedachten...",
    "audience_input_template.description": "Verzamel vragen, ervaringen en verhalen van gebruikers. Dit zorgt voor een groter bereik van betrokkenheid.",
    "audience_input_template.label": "Invoer van publiek",
    "blocklist.add_term_button": "Term toevoegen",
    "blocklist.add_terms": "Termen toevoegen - scheid meerdere termen met ;",
    "blocklist.delete_terms": "Termen verwijderen",
    "blocklist.description": "Termen beheren die automatisch moeten worden gerapporteerd.",
    "blocklist.edit_term": "Term bewerken",
    "blocklist.empty_list": "De zwarte lijst is leeg.",
    "blocklist.help_alternative_spellings_title": "Alternatieve spellingen:",
    "blocklist.help_case_note": "Er wordt rekening gehouden met hoofd- en kleine letters",
    "blocklist.help_character_replacements": "A → a | a → A | a → @ | a → 4 | i → 1 | e → 3 | o → 0 | s → $ | s → 5 | t → 7 | b → 8 | g → 9",
    "blocklist.help_singular_term_example": "Voorbeeld: “persoon” (enkelvoudige term) → “personen”. “personen” zou ook worden meegenomen als het “enkelvoudige term“-vakje niet is geselecteerd voor “persoon“. Dit geldt bijvoorbeeld ook voor “persoonlijkheid“.",
    "blocklist.help_singular_term_title": "Enkelvoudige term:",
    "blocklist.include_alternative_spellings": "Voeg alternatieve spellingen toe",
    "blocklist.only_singular_term": "Alleen enkelvoudige term",
    "blocklist.settings_for_term": "Instellingen voor de term",
    "blocklist.singular_term_tag": "Enkelvoudige term",
    "blocklist.terms_added_success": "{termsCount} termen succesvol toegevoegd",
    "blocklist.title": "Zwarte lijst",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "gedeselecteerd",
    "button.react_button_selected": "gekozen",
    "channels.no_channel": "Geen kanaal",
    "channels.no_channels_available": "Geen kanalen beschikbaar",
    "channels.select_channel": "Selecteer een kanaal",
    "channels.title": "Kanaal",
    "comment.cancel_button": "Annuleren",
    "comment.delete_button": "Verwijderen",
    "comment.delete_modal_heading": "Dit bericht verwijderen?",
    "comment.delete_modal_warning": "Deze actie kan niet ongedaan worden gemaakt",
    "comment.edit_button": "Bewerk",
    "comment.post_button": "Plaatsen",
    "comment.posting": "Plaatsen...",
    "comment.public_comment_subtitle": "Openbare opmerking",
    "comment.read_more_button": "Lees meer",
    "comment.reply_button": "Antwoorden",
    "comment.report_button": "Rapporteren",
    "comment.update_button": "Bijwerken",
    "comment.updating": "Bijwerken...",
    "comment_feedback.only_visible_to_you": "Alleen zichtbaar voor jou",
    "comment_slider.change_vote_button": "Je antwoord bijwerken",
    "comment_slider.community_guidelines_title": "Communityregels",
    "comment_slider.its_complicated": "Het is ingewikkeld",
    "comment_slider.no_with_reservations": "Nee, onder voorbehoud",
    "comment_slider.public_response": "Openbare reactie",
    "comment_slider.response": "antwoord",
    "comment_slider.responses": "antwoorden",
    "comment_slider.share_thoughts": "Deel je gedachten",
    "comment_slider.skip_change_vote": "Overslaan en verander stem",
    "comment_slider.skip_submit_vote": "Overslaan en stem indienen",
    "comment_slider.slide_to_respond": "Schuif om te reageren:",
    "comment_slider.strongly_no": "Zeker niet",
    "comment_slider.strongly_yes": "Zeker wel",
    "comment_slider.update_response": "Je antwoord bijwerken",
    "comment_slider.yes_with_reservations": "Ja, onder voorbehoud",
    "comment_slider_template.description": "Vraag gebruikers om op je vraag te reageren middels een spectrum (bijv. “Zeer oneens” tot “Zeer eens”).",
    "comment_slider_template.label": "Comment Slider",
    "common.are": "zijn",
    "common.is": "is",
    "common.loading": "Laden...",
    "community_guidelines.aria_popup_label": "{label} (pop-upvenster)",
    "community_guidelines.category_engage_respectfully": "Ga respectvol in gesprek",
    "community_guidelines.category_no_disruptive_behavior": "Geen verstorend gedrag",
    "community_guidelines.category_no_harmful_content": "Geen schadelijke inhoud",
    "community_guidelines.category_support_claims": "Ondersteun je beweringen",
    "community_guidelines.rule_avoid_derogatory_labels": "Vermijd denigrerende labels",
    "community_guidelines.rule_avoid_sarcasm": "Vermijd sarcasme en afwijzende antwoorden",
    "community_guidelines.rule_explain_constructively": "Leg meningsverschillen constructief uit",
    "community_guidelines.rule_express_civility": "Omschrijf je ideeën vanuit beleefdheid",
    "community_guidelines.rule_focus_on_ideas": "Focus op de ideeën, in plaats van oordelen over een ander",
    "community_guidelines.rule_no_illegal_content": "Geen illegale inhoud",
    "community_guidelines.rule_no_offtopic": "Geen off-topic berichten",
    "community_guidelines.rule_no_spam": "Geen spam of commerciële promotie",
    "community_guidelines.rule_no_violent_content": "Geen gewelddadige inhoud of oproep tot geweld",
    "community_guidelines.title": "Communityregels",
    "context_entry_points.joined_from": "Deelgenomen vanuit",
    "conversation_helper.about": "Over conversatiehelper",
    "conversation_helper.analyze_conversation": "Gesprek analyseren",
    "conversation_helper.checks_performed": "- **{count} controle(s)** uitgevoerd",
    "conversation_helper.conversation_analysis": "Gesprekanalyse",
    "conversation_helper.conversation_stats": "Gesprekstatistieken",
    "conversation_helper.conversation_summary": "Gesprekssamenvatting",
    "conversation_helper.current_guidance": "Huidige begeleiding",
    "conversation_helper.dashboard": "Gesprekshelperdashboard",
    "conversation_helper.disagree": "Oneens",
    "conversation_helper.explanation": "Uitleg",
    "conversation_helper.generate_new_guidance": "Nieuwe begeleiding genereren",
    "conversation_helper.generated_because": "Dit bericht is gegenereerd, omdat...",
    "conversation_helper.generated_by_ai": "Deze begeleiding is gegenereerd door AI.",
    "conversation_helper.guidance_messages_generated": "- **{count} begeleidingsbericht(en)** gegenereerd",
    "conversation_helper.guidance_visible_to_everyone": "Dit begeleidingsboodschap is zichtbaar voor iedereen.",
    "conversation_helper.hello_everyone": "Hallo allemaal!",
    "conversation_helper.help_history": "Hulpgeschiedenis",
    "conversation_helper.helpful": "Behulpzaam",
    "conversation_helper.last_analysis_none": "- Laatste gespreksanalyse: **Geen**",
    "conversation_helper.last_analysis_time": "- Laatste gespreksanalyse: **{time}**",
    "conversation_helper.new_comments_since_analysis": "- **{count} nieuwe opmerking(en)** sinds de laatste gespreksanalyse",
    "conversation_helper.no_problems": "Geen problemen gedetecteerd.",
    "conversation_helper.open_admin_dashboard": "Open beheerdashboard",
    "conversation_helper.problems_detected": "Problemen gedetecteerd!",
    "conversation_helper.related_space": "Gerelateerde ruimte",
    "conversation_helper.result": "Resultaat:",
    "conversation_helper.thank_you": "Bedankt",
    "conversationhelper.ai.hint": "Om de sfeer gastvrij en respectvol te houden, gebruiken we ook AI om te modereren. In dit gesprek geeft AI een samenvatting en tips om het gesprek constructief te houden.",
    "dashboard.table.demo.users": "Gebruikers",
    "date.days_abbrev": "{days}d",
    "date.hours_abbrev": "{hours}u",
    "date.minutes_abbrev": "{minutes}m",
    "date.months_abbrev": "{months}ma",
    "date.now": "nu",
    "date.years_abbrev": "{years}j",
    "demo.comment": "opmerking",
    "demo.comments": "opmerkingen",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "Oneens",
    "demo.fwrd": "FWRD",
    "demo.load_video_element": "Laad video-element",
    "demo.new_to_me": "Nieuw voor mij",
    "demo.pause": "PAUZE",
    "demo.play": "SPELEN",
    "demo.prev": "VORIGE",
    "demo.respect": "Respect",
    "demo.thank_you": "Bedankt",
    "demo.tile_admin_users_description": "Rechten van beheeraccounts aanpassen.",
    "demo.tile_admin_users_label": "Beheeraccounts",
    "demo.tile_topics_label": "Onderwerpen",
    "developer_tools.test_email_sent": "Testmail succesvol verzonden via {provider}",
    "dialogue_template.description": "Vraag gebruikers om op je vraag te reageren met een “ja“- of “nee“-antwoord.",
    "dialogue_template.label": "Dialoog",
    "disagree": "Oneens",
    "editorial_dash.title": "Redactiedashboard",
    "editorial_question.be_first": "Wees de eerste om je gedachten te delen",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Doe mee met de discussie",
    "editorial_question.lets_talk": "Laten we het hebben over...",
    "editorial_question.response_singular": "antwoord",
    "editorial_question.responses_plural": "antwoorden",
    "editorial_question.share_thoughts": "Deel je gedachten",
    "footer.made_by": "Gemaakt door",
    "form.add_button": "Toevoegen",
    "form.cancel_button": "Annuleren",
    "form.create_space_button": "Ruimte aanmaken",
    "form.delete_button": "Verwijderen",
    "form.edit_button": "Bewerk",
    "form.other": "Anders",
    "form.remove_button": "Verwijderen",
    "form.required_label": "{label} (vereist)",
    "form.save_button": "Opslaan",
    "form.update_button": "Bijwerken",
    "format.count_noun": "{count} {noun}",
    "language.de-DE": "Duits",
    "language.en-US": "Engels",
    "language.fr-FR": "Frans",
    "list.selected_items_count": "{keyCount} geselecteerde items",
    "loading": "Laden...",
    "login.account_not_impacted": "Je {siloName}-account is niet beïnvloed en nog steeds toegankelijk.",
    "login.continue_with_google": "Ga door met Google",
    "login.cookie_notice": "🍪 Deze discussieruimte gebruikt alleen essentiële cookies. We gebruiken geen cookies voor advertentiedoeleinden. [Meer informatie]({privacyNoticeLink}).",
    "login.default_admin_login_heading_label": "Welkom bij {psiBrandName}",
    "login.default_admin_login_subheading_label": "Log in met je beheeraccount om aan de slag te gaan",
    "login.default_login_heading_label": "Een ruimte voor gezonde discussies en verschillende perspectieven",
    "login.logging_in": "Inloggen...",
    "login.okay_button": "Oké",
    "modal.cancel_button": "Annuleren",
    "modal.close_button": "Sluiten",
    "modal.info_title": "Info",
    "moderation.add_explanation_to_user": "Uitleg aan de gebruiker toevoegen",
    "moderation.ai_mistake_explanation": "AI helpt ons bij het modereren van opmerkingen, maar soms kan het een fout maken. Als AI je verhindert een respectvolle mening te delen, stuur je opmerking dan naar een moderator ter beoordeling.",
    "moderation.ai_wrong_question": "Heeft AI het mis?",
    "moderation.approved_tag": "Goedgekeurd",
    "moderation.dash.block_user": "Blokkeer gebruiker",
    "moderation.dash.time": "keer",
    "moderation.dash.times": "keer",
    "moderation.dash.user_must_be_warned_2_times": "Een gebruiker moet 2 keer worden gewaarschuwd voordat hij kan worden geblokkeerd.",
    "moderation.dash.user_successfully_blocked": "{user} succesvol geblokkeerd",
    "moderation.dash.user_successfully_unblocked": "{user} was succesvol ongeblokkeerd",
    "moderation.explanations_sent_by_email": "Uitleg wordt per mail direct naar de gebruiker verzonden nadat je hebt afgekeurd.",
    "moderation.message_to_moderator_placeholder": "Bericht aan moderator...",
    "moderation.send_for_review_button": "Stuur naar een moderator voor beoordeling",
    "moderation.send_to_moderator_button": "Stuur naar moderator",
    "moderation.send_to_moderator_title": "Stuur naar moderator",
    "moderation.sending": "Verzenden...",
    "moderation.sent_for_review_message": "Je reactie is ter beoordeling naar een moderator gestuurd.",
    "moderation.sent_to_moderator": "Je reactie is ter beoordeling naar een moderator gestuurd.",
    "moderation.share_details": "Details delen",
    "moderation.strict_filter_notice": "⚠️ Ons moderatiefilter staat momenteel vrij streng om het hoogste veiligheidsniveau te garanderen! Als je denkt dat je bijdrage oneerlijk wordt afgewezen, neem dan contact op met ons moderatieteam!",
    "moderation.thank_you": "Bedankt!",
    "moderation.under_review": "Wordt beoordeeld",
    "moderation.use_ai_title": "✨ We gebruiken AI voor moderatie",
    "moderation.what_happens_next": "📫 Wat er daarna gebeurt",
    "moderationdash.title": "Moderatie dashboard",
    "most_popular.most_popular_label": "Het meest populair",
    "most_popular.most_recent_label": "Meest recent",
    "most_popular.show_more_button": "Meer reacties",
    "navigation_header.back_button": "Terug",
    "neutral": "Neutraal",
    "notification.dismiss_button": "Afwijzen",
    "perspectives.add_your_own": "Jouw eigen toevoegen",
    "perspectives.add_your_perspective": "Je perspectief toevoegen",
    "perspectives.enter_label_placeholder": "Voer een perspectieflabel in",
    "perspectives.how_relate_question": "Hoe verhoud je je tot dit probleem?",
    "perspectives.share_thoughts_button": "Deel je gedachten",
    "perspectives.title": "Perspectieven",
    "pin_comment.feature_label": "Uitlichten",
    "pin_comment.featured_label": "Uitgelicht",
    "poll.change_vote_button": "Verander mijn stem",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (jouw stem): {percent}%",
    "poll.submit_vote_button": "Stem indienen",
    "poll_question.add_option_button": "Optie toevoegen",
    "poll_question.option_placeholder": "Schrijf jouw optie...",
    "poll_question.options_label": "Peiling-opties",
    "poll_question.question_placeholder": "Schrijf jouw peilvraag...",
    "popup.close_button": "Venster sluiten",
    "privacy.only_visible_to_you": "🔒 Alleen zichtbaar voor jou",
    "profile.add_custom_name": "Een aangepaste naam toevoegen",
    "profile.beta_feedback_note": "Door deel te nemen aan onze bèta sta je toe dat wij je om feedback vragen over dit product.",
    "profile.consent_aria": "Ik ga akkoord met de communityregels, privacyverklaring en servicevoorwaarden.",
    "profile.consent_text": "Ik ga akkoord met de [communityregels]({communityGuidelinesLink}), [privacyverklaring]({privacyNoticeLink}) en [servicevoorwaarden]({termsOfServiceLink}).",
    "profile.custom_photo_label": "Aangepaste profielfoto",
    "profile.edit_module_button": "Bewerk {tLabel}",
    "profile.error_name_empty": "Aangepaste namen mogen niet leeg zijn.",
    "profile.error_name_invalid": "Aangepaste namen mogen alleen kleine letters en nummers bevatten.",
    "profile.error_name_looks_real": "Aangepaste namen mogen niet lijken op echte namen.",
    "profile.error_name_violates": "Deze aangepaste naam voldoet niet aan onze communityregels.",
    "profile.finish_button": "Afronden",
    "profile.helper_text": "Kies een naam en foto die verschijnt wanneer je in discussies berichten plaatst.",
    "profile.is_titled_writer": "Is aangestelde schrijver",
    "profile.loading": "Profiel laden...",
    "profile.module_photo_and_name": "foto en naam",
    "profile.name_label": "Profielnaam",
    "profile.photo_label": "Je profielfoto",
    "profile.photo_url_aria": "Foto-URL",
    "profile.photo_url_placeholder": "Foto-URL",
    "profile.please_wait": "Even geduld...",
    "profile.setup_title": "Stel je profiel in",
    "profile.title_heading": "Titel",
    "profile.title_placeholder": "Voer een titel in",
    "profile.username_placeholder": "user123",
    "profile_answers.admins_can_view": "Beheerders en moderators kunnen altijd je geschiedenis bekijken.",
    "profile_answers.discussion_history": "Discussiegeschiedenis",
    "profile_answers.history_private": "De geschiedenis van deze gebruiker is privé.",
    "profile_answers.rejected": "Je reactie is afgewezen door een moderator.",
    "profile_answers.under_review": "Je reactie wordt beoordeeld.",
    "profile_answers.visible_to_everyone": "Zichtbaar voor iedereen",
    "question.actions.close_button": "Sluiten",
    "question.actions.close_confirm_button": "Sluiten",
    "question.actions.close_modal_heading": "Deze ruimte sluiten?",
    "question.actions.copy_button": "Kopiëren",
    "question.actions.edit_button": "Bewerk",
    "question.actions.link_copied_toast": "Link gekopieerd naar klembord!",
    "question.actions.preview_button": "Voorbeeld",
    "question.actions.reopen_button": "Heropenen",
    "question.actions.reopen_confirm_button": "Heropenen",
    "question.actions.reopen_modal_description": "Heropen deze ruimte om het gesprek weer actief te maken.",
    "question.actions.reopen_modal_heading": "Deze ruimte opnieuw openen?",
    "question.add_content_label": "Inhoud toevoegen",
    "question.add_spaces_label": "Voeg ruimtes toe",
    "question.all_responses_tab": "Alle antwoorden",
    "question.count_noun_format": "{count} {noun}",
    "question.edit_page_title": "Bewerken: {name}",
    "question.edit_thread_header_section": "Ruimte-koptekst",
    "question.error_empty_prompt": "De stelling mag niet leeg zijn.",
    "question.error_prompt_too_long": "De stelling moet minder zijn dan {num} tekens.",
    "question.input_placeholder": "Deel je gedachten...",
    "question.moderation_label": "Moderatie",
    "question.no_comments_message": "Wees de eerste om je gedachten te delen",
    "question.no_comments_title": "Begin het gesprek",
    "question.prompt_label": "Stelling",
    "question.prosocial_format_label": "Prosociaal sjabloon",
    "question.public_response_subtitle": "Openbare reactie",
    "question.reaction_plural": "reacties",
    "question.reaction_singular": "reactie",
    "question.reply_placeholder": "Beantwoord {authorName}...",
    "question.reply_plural": "antwoorden",
    "question.reply_singular": "antwoord",
    "question.select_format_placeholder": "Selecteer een sjabloon",
    "question.upvote_singular": "upvote",
    "question.your_response_title": "Je reactie",
    "rating.its_complicated": "Het is ingewikkeld",
    "rating.no_with_reservations": "Nee, onder voorbehoud",
    "rating.strongly_no": "Zeker niet",
    "rating.strongly_yes": "Zeker wel",
    "rating.yes_with_reservations": "Ja, onder voorbehoud",
    "reaction_types.appreciation_plural": "waarderingen",
    "reaction_types.appreciation_singular": "waardering",
    "reaction_types.constructive": "Constructief",
    "reaction_types.controversial": "Controversieel",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Standaard set",
    "reaction_types.empathetic": "Empathisch",
    "reaction_types.enjoyable": "Aangenaam",
    "reaction_types.fun_space": "Leuke Ruimte",
    "reaction_types.funny": "Grappig",
    "reaction_types.helpful": "Behulpzaam",
    "reaction_types.insightful": "Inzichtelijk",
    "reaction_types.interesting": "Interessant",
    "reaction_types.nuanced": "Genuanceerd",
    "reaction_types.personal_space": "Persoonlijke Ruimte",
    "reaction_types.playful": "Speels",
    "reaction_types.reaction_set_label": "Reactieset",
    "reaction_types.relatable": "Herkenbaar",
    "reaction_types.serious_space": "Serieuze Ruimte",
    "reaction_types.surprising": "Verrassend",
    "related_content.add_content_button": "Inhoud toevoegen",
    "related_content.article_option": "Artikel",
    "related_content.audio_option": "Audio",
    "related_content.invalid_url_error": "Ongeldige URL-indeling. Voer een geldige URL in.",
    "related_content.label": "Gerelateerde inhoud",
    "related_content.learn_more": "Lees meer over dit onderwerp",
    "related_content.show_more_button": "Meer",
    "related_content.story_format_label": "Verhaalsjabloon",
    "related_content.story_url_label": "Verhaal-URL",
    "related_content.url_placeholder": "https://www.example.com",
    "related_content.video_option": "Video",
    "related_conversations.add_hint": "Voeg maximaal vier ruimtes toe.",
    "related_conversations.add_spaces_button": "Voeg ruimtes toe",
    "related_conversations.next_button": "Volgende",
    "related_conversations.no_spaces_available": "Geen ruimtes beschikbaar",
    "related_conversations.no_spaces_found": "Geen ruimtes gevonden",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.participant_plural": "deelnemers",
    "related_conversations.participant_singular": "deelnemer",
    "related_conversations.previous_button": "Vorige",
    "related_conversations.search_placeholder": "Zoeken",
    "related_conversations.title": "Gerelateerde gesprekken",
    "representing_perspectives_template.description": "Vraag gebruikers van een specifieke reeks perspectieven om op je vraag te reageren.",
    "representing_perspectives_template.description_5": "Scheid perspectieven met een enter.",
    "representing_perspectives_template.form_field_label": "Perspectieven",
    "representing_perspectives_template.helper_label": "Defineer jouw perspectieven",
    "representing_perspectives_template.label": "Representing Perspectives",
    "representing_perspectives_template.placeholder": "Schrijf 3-5 perspectieven...",
    "roles.moderator": "Moderator",
    "roles.owner": "Eigenaar",
    "satisfaction_survey_popover.question": "Hoe tevreden ben je met dit gespreksplatform?",
    "satisfaction_survey_popover.satisfied_label": "Zeer tevreden",
    "satisfaction_survey_popover.unsatisfied_label": "Zeer ontevreden",
    "saving": "Opslaan...",
    "search.placeholder": "Zoeken...",
    "settings.add_feature_button": "Functie toevoegen",
    "settings.add_format_button": "Sjabloon toevoegen",
    "settings.added_button": "Toegevoegd",
    "settings.added_format_button": "Toegevoegd",
    "settings.audience_input_description": "Verzamel vragen, ervaringen en verhalen van gebruikers. Dit zorgt voor een groter bereik van betrokkenheid.",
    "settings.audience_input_label": "Invoer van publiek",
    "settings.blocklist_description": "Blokkeer specifieke woorden van alle door de gebruiker ingediende berichten.",
    "settings.blocklist_label": "Zwarte lijst",
    "settings.channels_label": "Kanalen",
    "settings.comment_slider_description": "Vraag gebruikers om op je vraag te reageren middels een spectrum (bijv. “Zeer oneens” tot “Zeer eens”).",
    "settings.comment_slider_label": "Comment Slider",
    "settings.dialogue_description": "Vraag gebruikers om op je vraag te reageren met een “ja“- of “nee“-antwoord.",
    "settings.dialogue_label": "Dialoog",
    "settings.heading": "{psiBrandName} Instellingen",
    "settings.labs_heading": "Labs",
    "settings.moderation_heading": "Moderatie",
    "settings.prosocial_formats_description": "Elke discussieruimte krijgt structuur door een prosociaal geleid sjabloon.",
    "settings.prosocial_formats_heading": "Prosociale sjablonen",
    "settings.representing_perspectives_description": "Vraag gebruikers van een specifieke reeks perspectieven om op je vraag te reageren.",
    "settings.representing_perspectives_label": "Representing Perspectives",
    "settings.titled_writers_label": "Aangestelde schrijvers",
    "settings.video_voting_label": "Videopeiling",
    "simple_ranking.most_reactions": "De meeste reacties",
    "simple_ranking.newest": "Nieuwste",
    "single_response_help.same_question_title": "Dezelfde vraag, nieuw artikel?",
    "single_response_help.update_response_label": "Je vorige reactie aanpassen met nieuwe inzichten",
    "sort.all": "Alle",
    "sort.ascending": "A-Z",
    "sort.descending": "Z-A",
    "sort.most_recent": "Meest recent",
    "sort.top": "Boven",
    "sorting.oldest": "Oudste",
    "space.table.demo.name": "Naam",
    "space.table.demo.responses": "Antwoorden",
    "space.table.search": "Zoeken...",
    "spaces.column_actions": "Acties",
    "spaces.column_comments": "Opmerkingen",
    "spaces.column_created": "Gemaakt",
    "spaces.column_creationDate": "Gemaakt",
    "spaces.column_format": "Sjabloon",
    "spaces.column_name": "Naam",
    "spaces.column_responses": "Antwoorden",
    "spaces.column_status": "Status",
    "spaces.filter_active": "Actief",
    "spaces.filter_closed": "Gesloten",
    "spaces.format_required_label": "Prosociaal sjabloon (vereist)",
    "spaces.new_button": "Nieuwe ruimte",
    "spaces.new_space_title": "Nieuwe ruimte",
    "spaces.no_spaces_found": "Geen ruimtes gevonden",
    "spaces.no_spaces_yet": "Nog geen ruimtes",
    "spaces.prompt_label": "Stelling",
    "spaces.prompt_placeholder": "Schrijf een vraag of discussiestelling...",
    "spaces.status_active": "Actief",
    "spaces.status_closed": "Gesloten",
    "spaces.still_need_help": "Nog steeds hulp nodig?",
    "spaces.tab_label": "Ruimtes",
    "spaces.title": "Ruimtes",
    "spaces.visit_playbook": "Bezoek de PSI Playbook",
    "status.reload_to_see_effect": "Herlaad het artikel om het resultaat te zien",
    "status.reported": "Gemeld",
    "strongly_agree": "Sterk mee eens",
    "strongly_disagree": "Zeer oneens",
    "survey.strongly_agree": "Sterk mee eens",
    "survey.strongly_disagree": "Zeer oneens",
    "survey.tell_us_experience": "Vertel ons over je ervaring",
    "survey.thank_you": "Bedankt voor het delen van je ervaring!",
    "suspension.moderator_blocked_you": "Een moderator heeft je geblokkeerd",
    "suspension.moderator_unblocked_you": "Een moderator heeft je gedeblokkeerd",
    "suspension.moderator_warned_you": "Een moderator heeft je gewaarschuwd",
    "tag.beta": "Bèta",
    "template.perspectives_description": "Scheid perspectieven met een enter.",
    "template.perspectives_label": "Perspectieven",
    "text.character_count_max": "{count}/{max} max. tekens",
    "text.character_count_min": "{min} min. tekens",
    "text.character_count_over_max": "{count}/{max} max. tekens",
    "text.character_count_progress_min": "{count}/{min} min. tekens",
    "time.format": "{time}",
    "upvote.aria_label": "Upvote",
    "user.member": "Lid",
    "user_info.account_button": "Account",
    "user_info.log_in_button": "Inloggen",
    "user_info.log_out_button": "Uitloggen",
    "user_info.profile_button": "Profiel",
    "video_link.go_to_video": "Ga naar video",
    "video_voting.community_average": "Community-gemiddelde",
    "video_voting.continue_button": "Doorgaan",
    "video_voting.create_new_voting": "Maak een nieuwe peiling",
    "video_voting.deactivate_all": " je kunt dit deactiveren voor alle video's.",
    "video_voting.discourse": "Gesprek",
    "video_voting.enable_all_videos": "Stemmen voor alle video's inschakelen",
    "video_voting.enable_voting": "Schakel stemmen in",
    "video_voting.join_discussion": "Doe mee met de discussie",
    "video_voting.manage_voting_admin": "Peiling beheren (beheerder)",
    "video_voting.no_data_available": "Geen stemgegevens beschikbaar.",
    "video_voting.select_voting_for_article": "Selecteer een peiling voor dit artikel",
    "video_voting.settings": "instellingen",
    "video_voting.start_video": "Start video",
    "video_voting.template_missing": "Het videopeiling-sjabloon ontbreekt",
    "video_voting.time": "Tijd:",
    "video_voting.title": "Videopeiling",
    "video_voting.vote_anonymously": "Anoniem stemmen",
    "video_voting.votings_tab": "Stemmen",
    "video_voting.you": "Jij",
    "voting.no": "Nee",
    "voting.yes": "Ja",
    "zdf_admin.votings": "Stemmen",
    "zdf_article.manage_teaser_positions": "Beheer teaser-posities",
    "zdf_article.pick_positions": "Kies maximaal 2 posities",
    "zdf_article.teaser_position_last_paragraph": "Na de laatste paragraaf in de hoofdtekst",
    "zdf_article.teaser_position_second_paragraph": "Na de tweede paragraaf in de hoofdtekst",
    "zdf_article.teaser_position_second_subheading": "Na de tweede subkop in de hoofdtekst",
    "zdf_channels.add_channel_title": "Kanaal toevoegen",
    "zdf_channels.add_members": "Leden toevoegen",
    "zdf_channels.channel_name_label": "Kanaalnaam",
    "zdf_channels.default_channel_access": "Alle beheeraccounts hebben toegang tot het standaardkanaal.",
    "zdf_channels.delete_channel_title": "Kanaal verwijderen",
    "zdf_channels.delete_confirmation": "Moet dit kanaal echt worden verwijderd?",
    "zdf_channels.edit_channel_title": "Kanaal bewerken",
    "zdf_channels.image_url_label": "Afbeelding-URL",
    "zdf_channels.member_search_field": "Ledenzoekveld",
    "zdf_channels.members_label": "Leden",
    "zdf_moddashboard.ai_explanation": "AI-uitleg",
    "{count} {noun}": "{count} {noun}"
}
